import type { ReactNode } from 'react';
import { Header, type EyebrowTone, type TitleAccent } from './_shared';

export type FigureSlideProps = {
  eyebrow: ReactNode;
  eyebrowTone?: EyebrowTone;
  title: ReactNode;
  titleAccent?: TitleAccent;
  sub?: ReactNode;
  image: string;
  alt: string;
  /** Set true to render the image inside a white card. Default false (image breathes on beige). */
  framed?: boolean;
};

export function FigureSlide({
  eyebrow,
  eyebrowTone,
  title,
  titleAccent,
  sub,
  image,
  alt,
  framed = false,
}: FigureSlideProps) {
  return (
    <div className="slide-body">
      <Header
        eyebrow={eyebrow}
        eyebrowTone={eyebrowTone}
        title={title}
        titleAccent={titleAccent}
        sub={sub}
      />
      <div className="sn-work">
        <div className={`sn-figure${framed ? ' sn-figure--framed' : ''}`}>
          <img src={image} alt={alt} />
        </div>
      </div>
    </div>
  );
}
